import {mainQuery} from '@github-ui/react-core/future/main-query'

import {commitsAppBuilder} from '../config/app-builder'
import type {CommitsPayload} from '../types/commits-types'

export const commitsRoute = commitsAppBuilder.createQueryRouteConfig('commitsRoute', {
  path: '/:owner/:repo/commits',
  queries: [
    mainQuery<CommitsPayload>({
      queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
    }),
  ],
})
